import { PaymentTypes } from "../../../common/enums";

// ─── Plan summary surfaced on the search dropdown and selected-user card ──

export interface IGymUserPlanSummary {
  subscriptionPlanId: number;
  planName: string;
  remainingVisits: number | null;
  isUnlimited: boolean;
  activeUntil: string | null;
}

// ─── User search result ───────────────────────────────────────────────────

export interface IGymUserSearchResult {
  id: number;
  firstName: string;
  lastName: string | null;
  phoneNumber: string | null;
  email: string | null;
  rfidBandId: string | null;
  profilePhotoUrl: string | null;
  activePlan: IGymUserPlanSummary | null;
  openVisitId: number | null;
}

// ─── Visit (history row + currently-inside card) ──────────────────────────

export interface IGymVisitViewModel {
  id: number;
  userId: number;
  userFullName: string;
  rfidBandId: string | null;
  profilePhotoUrl: string | null;
  checkedInAt: string;
  checkedOutAt: string | null;
  paymentType: PaymentTypes | null;
  pricePaid: number | null;
  subscriptionPlanId: number | null;
  planName: string | null;
  visitIndex: number | null;
  planInitialVisits: number | null;
  checkedInByUserId: number;
  checkedInByName: string | null;
  checkedOutByUserId: number | null;
  checkedOutByName: string | null;
  isForcedCheckOut: boolean;
  notes: string | null;
}

// ─── Check-in/out payload + result ────────────────────────────────────────

export interface IGymCheckInPayload {
  userId: number;
  paymentType?: PaymentTypes | null;
  pricePaid?: number | null;
  subscriptionPlanId?: number | null;
  notes?: string | null;
}

export enum GymCheckInAction {
  CheckedIn = 10,
  CheckedOut = 20,
  DuplicateIgnored = 30,
  PaymentRequired = 40,
}

export interface IGymCheckInResult {
  action: GymCheckInAction;
  visit: IGymVisitViewModel | null;
  message: string | null;
}

// ─── Revert last action ───────────────────────────────────────────────────

export interface IGymLastAction {
  visitId: number;
  action: GymCheckInAction;
}

export interface IGymLastActionResponse {
  lastAction: IGymLastAction | null;
}

// ─── History response ─────────────────────────────────────────────────────

export interface IGymHistoryPage {
  items: IGymVisitViewModel[];
  totalCount: number;
  hasMore: boolean;
}

// ─── Stats ────────────────────────────────────────────────────────────────

export interface IGymStats {
  insideCount: number;
  todayCount: number;
}

// ─── Filters ──────────────────────────────────────────────────────────────

export type HistoryFilter =
  | "today"
  | "thisWeek"
  | "dateRange"
  | "all"
  | "inside";

export const HISTORY_PAGE_SIZE = 25;

// ─── Helpers ──────────────────────────────────────────────────────────────

export const getMemberFullName = (
  m: Pick<IGymUserSearchResult, "firstName" | "lastName">
) => `${m.firstName}${m.lastName ? " " + m.lastName : ""}`.trim();

export const getInitials = (fullName: string) =>
  fullName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
